import { supabase } from "../supabaseClient";
import { bucketingForChangeUnit } from "./paymentApi";
import axios from "axios";

function applicantType(i) {
  switch (i) {
    case 0:
      return "first";
    case 1:
      return "second";
    case 2:
      return "third";
    case 3:
      return "fourth";
    default:
      return "";
  }
}

function UploadDoc(fileObject, fileName) {
  return new Promise(async (resolve, reject) => {
		let uploadResponse = await supabase.storage.from("AgreementKYCDocuments").upload(fileName, fileObject, { upsert: true });
    if (uploadResponse.data) {
			const _url = supabase.storage.from("AgreementKYCDocuments").getPublicUrl(fileName).data.publicURL;
      resolve({ success: true, url: _url });
    } else {
      resolve({ success: false, error: uploadResponse?.error });
    }
  });
}

async function submitAgreementForm(obj, agreementKYCs, leadName, allotmentPaymentId) {
  return new Promise((resolve, reject) => {
    const processAgreement = async (agreement, i) => {
      let obj = {
        type: applicantType(i),
        agreementFormId: null,
        applicant: {
          salutation: agreement.salutation,
          firstName: agreement.firstName,
          middleName: agreement.middleName,
          lastName: agreement.lastName,
          leadDob: Date.parse(agreement.leadDob),
          age: agreement.age,
          gender: agreement.gender,
          occupation: agreement.occupation,
          otherOccupation: agreement.otherOccupation,
          contactNumber: agreement.contactNumber,
          email: agreement.email,
          panNumber: agreement.panNumber,
          aadharNumber: agreement.aadharNumber,
          addressLine1: agreement.addressLine1,
          addressLine2: agreement.addressLine2,
          addressLine3: agreement.addressLine3,
          pincode: agreement.pincode,
          country: agreement.country,
          state: agreement.state,
          city: agreement.city,
          nameAsperPAN: agreement.nameAsperPAN,
          aadharFileUrl: agreement.aadharFileUrl,
          panFileUrl: agreement.panFileUrl,
          countryCode: agreement.countryCode,
          addressAsPrimaryApplicant: agreement.addressAsPrimaryApplicant,
          loanSanctionUrl: agreement.loanSanctionUrl,
        },
        POA: agreement.poa
          ? {
              salutation: agreement.poaData.salutation,
              firstName: agreement.poaData.firstName,
              middleName: agreement.poaData.middleName,
              lastName: agreement.poaData.lastName,
              age: agreement.poaData.age,
              gender: agreement.poaData.gender,
              occupation: agreement.poaData.occupation,
              otherOccupation: agreement.poaData.otherOccupation,
              contactNumber: agreement.poaData.contactNumber,
              email: agreement.poaData.email,
              panNumber: agreement.poaData.panNumber,
              aadharNumber: agreement.poaData.aadharNumber,
              addressLine1: agreement.poaData.addressLine1,
              addressLine2: agreement.poaData.addressLine2,
              addressLine3: agreement.poaData.addressLine3,
              pincode: agreement.poaData.pincode,
              country: agreement.poaData.country,
              state: agreement.poaData.state,
              city: agreement.poaData.city,
              nameAsperPAN: agreement.poaData.nameAsperPAN,
              aadharFileUrl: agreement.poaData.aadharFileUrl,
              panFileUrl: agreement.poaData.panFileUrl,
            }
          : null,
      };
      if (typeof agreement?.loanSanctionUrl?.url === "object") {
				const UploadEmailDocResponse = await UploadDoc(agreement?.loanSanctionUrl?.url, `${leadName}/${agreement?.loanSanctionUrl?.url?.name}`);
        if (UploadEmailDocResponse.success) {
          obj.applicant.loanSanctionUrl.url = UploadEmailDocResponse.url;
        } else {
					throw UploadEmailDocResponse;
        }
      }
      if (typeof agreement.aadharFileUrl.url1 === "object") {
				const UploadEmailDocResponse = await UploadDoc(agreement.aadharFileUrl.url1, `${leadName}/${agreement.aadharFileUrl.url1.name}`);
        if (UploadEmailDocResponse.success) {
          obj.applicant.aadharFileUrl.url1 = UploadEmailDocResponse.url;
        } else {
					throw UploadEmailDocResponse;
        }
      }
      if (typeof agreement.aadharFileUrl.url2 === "object") {
				const UploadEmailDocResponse = await UploadDoc(agreement.aadharFileUrl.url2, `${leadName}/${agreement.aadharFileUrl.url2.name}`);
        if (UploadEmailDocResponse.success) {
          obj.applicant.aadharFileUrl.url2 = UploadEmailDocResponse.url;
        } else {
					throw UploadEmailDocResponse;
        }
      }

      if (typeof agreement.panFileUrl.url === "object") {
				const UploadEmailDocResponse = await UploadDoc(agreement.panFileUrl.url, `${leadName}/${agreement.panFileUrl.url.name}`);
        if (UploadEmailDocResponse.success) {
          obj.applicant.panFileUrl.url = UploadEmailDocResponse.url;
        } else {
					throw UploadEmailDocResponse;
        }
      }
      if (agreement.poa) {
        if (typeof agreement?.poaData?.aadharFileUrl.url1 === "object") {
          const UploadEmailDocResponse = await UploadDoc(
            agreement.poaData.aadharFileUrl.url1,
            `${leadName}/${agreement.poaData.aadharFileUrl.url1.name}`
          );
          if (UploadEmailDocResponse.success) {
            obj.POA.aadharFileUrl.url1 = UploadEmailDocResponse.url;
          } else {
						throw UploadEmailDocResponse;
          }
        }
        if (typeof agreement?.poaData?.aadharFileUrl.url2 === "object") {
          const UploadEmailDocResponse = await UploadDoc(
            agreement.poaData.aadharFileUrl.url2,
            `${leadName}/${agreement.poaData.aadharFileUrl.url2.name}`
          );
          if (UploadEmailDocResponse.success) {
            obj.POA.aadharFileUrl.url2 = UploadEmailDocResponse.url;
          } else {
						throw new UploadEmailDocResponse;
          }
        }

        if (typeof agreement?.poaData?.panFileUrl.url === "object") {
          const UploadEmailDocResponse = await UploadDoc(
            agreement.poaData.panFileUrl.url,
            `${leadName}/${agreement.poaData.panFileUrl.url.name}`
          );
          if (UploadEmailDocResponse.success) {
            obj.POA.panFileUrl.url = UploadEmailDocResponse.url;
          } else {
						throw UploadEmailDocResponse;
          }
        }
      }

      return obj;
    };

    Promise.all(agreementKYCs.map(processAgreement))
      .then((data) => {
        let applicantsArray = [];
        data.map((item) => {
					applicantsArray.push({ applicantId: null, payload: item })
				})
        // return supabase.from("Applicants").insert(data);
				axios.post(process.env.REACT_APP_PAYMENT_LINK_URL + 'agreement/updateAgreementFormPayload', {
              AgreementForm: [{ agreementFormId: null, payload: obj }],
              Applicants: applicantsArray,
              CRM: [{ allotmentPaymentId: null, payload: null }],
					AllotmentPayment: [{ allotmentPaymentId: allotmentPaymentId, payload: { isAgreementFormFilled: true } }]
				}).then((resp) => {
            console.log("resp::", resp);
					resolve({ success: true });
          })
          .catch((err) => {
            console.log("err", err);
						reject({ success: false, err });
					});
			}).catch((err) => {
				reject({ success: false, error: err.error });
				console.log("err", err);

          });
      })
}

async function updateAllotmentPaymentAgreement(obj, id) {
	const { data, error } = await supabase.from("AllotmentPayment").update(obj).eq("allotmentPaymentId", id);
  if (data) return data;
  else throw error;
}

async function getAgreement(allotmentPaymentId) {
  return new Promise((resolve, reject) => {
    supabase
      .from("AgreementForm")
      .select("*,ChangeApplicantRequests!left(*)")
      .eq("allotmentPaymentId", allotmentPaymentId)
      .then((afResp) => {
        console.log("Agreemnt Change Applicant", afResp);
        if (afResp?.data[0]) {
          supabase
            .from("Applicants")
            .select("*")
            .eq("agreementFormId", afResp.data[0].agreementFormId)
            .order("created_at", { ascending: true })
            .then((responseObj) => {
              if (responseObj?.data[0]) {
								resolve({ agreementForm: afResp.data[0], applicant: responseObj });
              } else {
                reject({ success: false });
              }
            })
            .catch((err) => {
              console.log("error in getting agreement: ", err);
              reject({ success: false });
            });
        } else {
          reject({ success: false });
        }
      })
      .catch((err) => {
        console.log("error in getting agreement: ", err);
        reject({ success: false });
      });
  });
}

async function updateAgreement(
  objData,
  agreementFormId,
  obj,
  id,
  changeApplicant,
  allotmentPaymentId,
  payload,
  sdrPercentage,
  filesToDelete,
  leadName
) {
  if (filesToDelete.length > 0) {

    const deletefiles = filesToDelete.map(async (file) => {

			const { data, error } = await supabase.storage.from("AgreementKYCDocuments").remove([`${leadName}/${file.split("/").pop()}`]);

      if (error) {
        console.error(`Error deleting file ${file}:`, error);
      }
    });
    await Promise.all(deletefiles);
  }
  if (typeof obj?.applicant?.loanSanctionUrl?.url === "object") {
		const UploadEmailDocResponse = await UploadDoc(obj?.applicant?.loanSanctionUrl?.url, `${leadName}/${obj?.applicant?.loanSanctionUrl?.url?.name}`);
    if (UploadEmailDocResponse.success) {
      obj.applicant.loanSanctionUrl.url = UploadEmailDocResponse.url;
    } else {
			throw UploadEmailDocResponse;
    }
  }
	if (typeof (obj.applicant.aadharFileUrl.url1) === "object") {
		const UploadEmailDocResponse = await UploadDoc(obj.applicant.aadharFileUrl.url1, `${leadName}/${obj.applicant.aadharFileUrl.url1.name}`);
    if (UploadEmailDocResponse.success) {
      obj.applicant.aadharFileUrl.url1 = UploadEmailDocResponse.url;
    } else {
			throw UploadEmailDocResponse;
    }
  }
	if (typeof (obj.applicant.aadharFileUrl.url2) === "object") {
		const UploadEmailDocResponse = await UploadDoc(obj.applicant.aadharFileUrl.url2, `${leadName}/${obj.applicant.aadharFileUrl.url2.name}`);
    if (UploadEmailDocResponse.success) {
      obj.applicant.aadharFileUrl.url2 = UploadEmailDocResponse.url;
    } else {
			throw UploadEmailDocResponse;
    }
  }

	if (typeof (obj.applicant.panFileUrl.url) === "object") {
		const UploadEmailDocResponse = await UploadDoc(obj.applicant.panFileUrl.url, `${leadName}/${obj.applicant.panFileUrl.url.name}`);
    if (UploadEmailDocResponse.success) {
      obj.applicant.panFileUrl.url = UploadEmailDocResponse.url;
    } else {
			throw UploadEmailDocResponse;
    }
  }
  if (obj.POA) {
    if (typeof obj?.POA?.aadharFileUrl.url1 === "object") {
			const UploadEmailDocResponse = await UploadDoc(obj.POA.aadharFileUrl.url1, `${leadName}/${obj.POA.aadharFileUrl.url1.name}`);
      if (UploadEmailDocResponse.success) {
        obj.POA.aadharFileUrl.url1 = UploadEmailDocResponse.url;
      } else {
				throw UploadEmailDocResponse;
      }
    }
    if (typeof obj?.POA?.aadharFileUrl.url2 === "object") {
			const UploadEmailDocResponse = await UploadDoc(obj.POA.aadharFileUrl.url2, `${leadName}/${obj.POA.aadharFileUrl.url2.name}`);
      if (UploadEmailDocResponse.success) {
        obj.POA.aadharFileUrl.url2 = UploadEmailDocResponse.url;
      } else {
				throw UploadEmailDocResponse;
      }
    }
    if (typeof obj?.POA?.panFileUrl.url === "object") {
			const UploadEmailDocResponse = await UploadDoc(obj.POA.panFileUrl.url, `${leadName}/${obj.POA.panFileUrl.url.name}`);
      if (UploadEmailDocResponse.success) {
        obj.POA.panFileUrl.url = UploadEmailDocResponse.url;
      } else {
				throw UploadEmailDocResponse;
      }
    }
  }
  let crmObj = [{ allotmentPaymentId: null, payload: null }];
  let allotmentObj = [{ allotmentPaymentId: null, payload: null }];
  if (changeApplicant) {
		crmObj = [{
			allotmentPaymentId: allotmentPaymentId, payload: {
          isApproved: true,
          crmStatusId: 2,
          isParkingSelectionSubmitted: false,
          newUnitCost: payload, //oldUnitCost
          last_updated_at: Date.now(),
          isChangeApplicantRaised: true,
          sdrPercentage: sdrPercentage,
			}
		}];

		allotmentObj = [{
			allotmentPaymentId: allotmentPaymentId, payload: {
          isBucketingApplied: false,
          unitCost: payload,
			}
		}]
  }
  return new Promise((resolve, reject) => {
		axios.post(process.env.REACT_APP_PAYMENT_LINK_URL + 'agreement/updateAgreementFormPayload',
        {
				AgreementForm: [{ agreementFormId: agreementFormId, payload: objData }],
          Applicants: [{ applicantId: id, payload: obj }],
          CRM: crmObj,
				AllotmentPayment: allotmentObj
			}).then((resp) => {
        console.log("resp::", resp);
        resolve({ success: true });
      })
      .catch((err) => {
        console.log("err", err);
        reject({ success: false });
      });
  });
}

async function updateAgreementInsertApplicantForm(
  obj,
  data,
  id,
  changeApplicant,
  allotmentPaymentId,
  payload,
  sdrPercentage,
  filesToDelete,
  leadName
) {
  if (filesToDelete.length > 0) {
    const deletefiles = filesToDelete.map(async (file) => {
			const { data, error } = await supabase.storage.from("AgreementKYCDocuments").remove([`${leadName}/${file.split("/").pop()}`]);
      if (error) {
        console.error(`Error deleting file ${file}:`, error);
      }
    });
    await Promise.all(deletefiles);
  }
  const newData = await Promise.all(
    data.map(async (obj) => {
      if (typeof obj?.applicant?.loanSanctionUrl?.url === "object") {

				const UploadEmailDocResponse = await UploadDoc(obj?.applicant?.loanSanctionUrl?.url, `${leadName}/${obj?.applicant?.loanSanctionUrl?.url?.name}`);
        if (UploadEmailDocResponse.success) {
          obj.applicant.loanSanctionUrl.url = UploadEmailDocResponse.url;
        } else {
					throw UploadEmailDocResponse;
        }
      }
      if (typeof obj.applicant.aadharFileUrl.url1 === "object") {
				const UploadEmailDocResponse = await UploadDoc(obj.applicant.aadharFileUrl.url1, `${leadName}/${obj.applicant.aadharFileUrl.url1.name}`);
        if (UploadEmailDocResponse.success) {
          obj.applicant.aadharFileUrl.url1 = UploadEmailDocResponse.url;
        } else {
					throw UploadEmailDocResponse;
        }
      }
      if (typeof obj.applicant.aadharFileUrl.url2 === "object") {
				const UploadEmailDocResponse = await UploadDoc(obj.applicant.aadharFileUrl.url2, `${leadName}/${obj.applicant.aadharFileUrl.url2.name}`);
        if (UploadEmailDocResponse.success) {
          obj.applicant.aadharFileUrl.url2 = UploadEmailDocResponse.url;
        } else {
					throw UploadEmailDocResponse;
        }
      }
      if (typeof obj.applicant.panFileUrl.url === "object") {
				const UploadEmailDocResponse = await UploadDoc(obj.applicant.panFileUrl.url, `${leadName}/${obj.applicant.panFileUrl.url.name}`);
        if (UploadEmailDocResponse.success) {
          obj.applicant.panFileUrl.url = UploadEmailDocResponse.url;
        } else {
					throw UploadEmailDocResponse;
        }
      }
      if (obj.POA) {
        if (typeof obj?.POA?.aadharFileUrl.url1 === "object") {
					const UploadEmailDocResponse = await UploadDoc(obj.POA.aadharFileUrl.url1, `${leadName}/${obj.POA.aadharFileUrl.url1.name}`);
          if (UploadEmailDocResponse.success) {
            obj.POA.aadharFileUrl.url1 = UploadEmailDocResponse.url;
          } else {
						throw UploadEmailDocResponse;
          }
        }
        if (typeof obj?.POA?.aadharFileUrl.url2 === "object") {
					const UploadEmailDocResponse = await UploadDoc(obj.POA.aadharFileUrl.url2, `${leadName}/${obj.POA.aadharFileUrl.url2.name}`);
          if (UploadEmailDocResponse.success) {
            obj.POA.aadharFileUrl.url2 = UploadEmailDocResponse.url;
          } else {
						throw UploadEmailDocResponse;
          }
        }
        if (typeof obj?.POA?.panFileUrl.url === "object") {
					const UploadEmailDocResponse = await UploadDoc(obj.POA.panFileUrl.url, `${leadName}/${obj.POA.panFileUrl.url.name}`);
          if (UploadEmailDocResponse.success) {
            obj.POA.panFileUrl.url = UploadEmailDocResponse.url;
          } else {
						throw UploadEmailDocResponse;
          }
        }
      }
      return obj;
    })
  );

  let crmObj = [{ allotmentPaymentId: null, payload: null }];
  let allotmentObj = [{ allotmentPaymentId: null, payload: null }];
  if (changeApplicant) {
		crmObj = [{
			allotmentPaymentId: allotmentPaymentId, payload: {
          isApproved: true,
          crmStatusId: 2,
          isParkingSelectionSubmitted: false,
          newUnitCost: payload, //@todo need to check this
          last_updated_at: Date.now(),
          isChangeApplicantRaised: true,
          sdrPercentage: sdrPercentage,
			}
		}];


		allotmentObj = [{
			allotmentPaymentId: allotmentPaymentId, payload: {
          isBucketingApplied: false,
          unitCost: payload,
			}
		}]

  }
  return new Promise((resolve, reject) => {
    let applicantsArray = [];
    newData.map((item) => {
			applicantsArray.push({ applicantId: null, payload: item })
		})
		axios.post(process.env.REACT_APP_PAYMENT_LINK_URL + 'agreement/updateAgreementFormPayload',
        {
          AgreementForm: [{ agreementFormId: id, payload: obj }],
          Applicants: applicantsArray,
          CRM: crmObj,
				AllotmentPayment: allotmentObj
			}).then((resp) => {
        console.log("resp::", resp);
        resolve({ success: true });
      })
      .catch((err) => {
        console.log("err", err);
        reject({ success: false });
      });
  });
}

async function deleteApplicant(id) {
  let query = supabase.from("Applicants").delete().eq("applicantId", id);
  const { data, error } = await query;
  if (data) return data;
  else throw error;
}

async function getAgreementForm(allotmentPaymentId) {
  return new Promise((resolve, reject) => {
    supabase
      .from("AgreementForm")
      .select("*")
      .eq("allotmentPaymentId", allotmentPaymentId)
      .then((afResp) => {
        resolve(afResp);
      })
      .catch((err) => {
        console.log("error in getting agreement: ", err);
        reject({ success: false });
      });
  });
}

async function getStampDetails(id) {
  return new Promise((resolve, reject) => {
    supabase
      .from("StampDetails")
      .select("*")
      .eq("bookingId", id)
      .then((afResp) => {
        resolve(afResp);
      })
      .catch((err) => {
        console.log("error in getting Stamp Details: ", err);
        reject({ success: false });
      });
  });
}

async function getSlotBooking(id) {
  return new Promise((resolve, reject) => {
    supabase
      .from("SlotBookings")
      .select("*")
      .eq("bookingId", id)
      .then((afResp) => {
        resolve(afResp);
      })
      .catch((err) => {
        console.log("error in getting slot Booking: ", err);
        reject({ success: false });
      });
  });
}

async function getPincodes() {
  const { data, error } = await supabase.from("Pincodes").select("*");
  if (data) return data;
  else throw error;
}

async function getPincodeData(pincode) {
	const { data, error } = await supabase.from("Pincodes").select("*").eq("pincode", pincode);
  if (data) return data;
  else throw error;
}

async function getBankList() {
  const { data, error } = await supabase.from("BankDetails").select("*");
  if (data) return data;
  else throw error;
}

async function getNBFCList() {
  const { data, error } = await supabase.from("NBFCDetails").select("*");
  if (data) return data;
  else throw error;
}

async function changeApplicantReq(userId, allotmentPaymentId, agreementFormId, status, isChangeApplicantRaised) {
  return new Promise((resolve, reject) => {
    supabase
      .from("Users")
      .select("parentId")
      .eq("userId", userId)
      .then((resp) => {
        if (resp.data) {
          if (isChangeApplicantRaised) {
            supabase
              .from("ChangeApplicantRequests")
              .update({ status: "pending" })
              .eq("agreementFormId", agreementFormId)
              .then((changeResp) => {
                if (changeResp?.data) {
                  supabase
                    .from("CRM")
                    .update({
                      crmStatusId: 3,
                      isChangeApplicantRaised: false,
                      requestPendingWith: resp.data[0].parentId,
                      changeApplicantCrmStatusId: status,
                      last_updated_at: Date.now(),
                    })
                    .eq("allotmentPaymentId", allotmentPaymentId)
                    .then((agreementFormResp) => {
                      if (agreementFormResp?.data) {
                        resolve({ success: true });
                      } else {
                        reject({ success: false });
                      }
                    })
                    .catch((err) => {
                      console.log("error in Change Applicant Req: ", err);
                      reject({ success: false });
                    });
                } else {
                  reject({ success: false });
                }
              })
              .catch((err) => {
                console.log("error in Change Applicant Req: ", err);
                reject({ success: false });
              });
          } else {
            supabase
              .from("ChangeApplicantRequests")
							.insert({ agreementFormId: agreementFormId, status: "pending", requestPendingWith: resp.data[0].parentId })
              .then((changeResp) => {
                if (changeResp?.data) {
                  supabase
                    .from("CRM")
                    .update({
                      crmStatusId: 3,
                      isChangeApplicantRaised: false,
                      requestPendingWith: resp.data[0].parentId,
                      changeApplicantCrmStatusId: status,
                      last_updated_at: Date.now(),
                    })
                    .eq("allotmentPaymentId", allotmentPaymentId)
                    .then((agreementFormResp) => {
                      if (agreementFormResp?.data) {
                        resolve({ success: true });
                      } else {
                        reject({ success: false });
                      }
                    })
                    .catch((err) => {
                      console.log("error in Change Applicant Req: ", err);
                      reject({ success: false });
                    });
                } else {
                  reject({ success: false });
                }
              })
              .catch((err) => {
                console.log("error in Change Applicant Req: ", err);
                reject({ success: false });
              });
          }
        } else {
          reject({ success: false });
        }
      })
      .catch((err) => {
        console.log("error in getting CRM ParentId: ", err);
        reject({ success: false });
      });
  });
}

async function addCRMLogs(obj) {
  const { data, error } = await supabase.from("CRMLogs").insert(obj);
  if (data) return data;
  else throw error;
}

async function updateCRMAgreement(obj, id) {
	const { data, error } = await supabase.from("CRM").update(obj).eq("allotmentPaymentId", id);
  if (data) return data;
  else throw error;
}

async function getBookingForm(id) {
	const { data, error } = await supabase.from("BookingForm").select("*").eq("bookingFormId", id);
  if (data) return data;
  else throw error;
}

async function getCompanyDetails(buId) {
  try {
    const response = await axios.get(`${process.env.REACT_APP_PAYMENT_LINK_URL}agreement/getCompanyDetails?buId=${buId}`);
    return response?.data?.companyName;
  } catch (error) {
    console.log("getCompanyDetails error", error);
    return null;
  }
}

export {
  submitAgreementForm,
  updateAllotmentPaymentAgreement,
  getAgreement,
  updateAgreement,
  updateAgreementInsertApplicantForm,
  deleteApplicant,
  getAgreementForm,
  getStampDetails,
  getSlotBooking,
  getPincodeData,
  getPincodes,
  getBankList,
  getNBFCList,
  changeApplicantReq,
  addCRMLogs,
  updateCRMAgreement,
  getBookingForm,
  UploadDoc,
  getCompanyDetails,
};
